module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-8.d77a02f6.svg";